<template>
    <div class="bigReportContainer" :class="{'bigReportContainerDark' : isDark}">
        <TitleBar title="大数据报告" :txt="txt" :type="type"></TitleBar>
        <div class="bigReportBox" @click="goModelList">
            <div class="bigReportCard">
                <div class="top">
                    <div class="title">
                        <span class="home">{{bigData.home_team}}</span>
                        <span>综合实力</span>
                        <span class="guest">{{bigData.guest_team}}</span>
                    </div>
                    <div class="barBox">
                        <span :class="{'home':true, 'isAndroid':isAndroid}" :style="{width: bigData.compare_home_strength + '%'}">{{bigData.compare_home_strength}}%</span>
                        <span :class="{'guest':true, 'isAndroid':isAndroid}" :style="{width: bigData.compare_guest_strength + '%'}">{{bigData.compare_guest_strength}}%</span>
                    </div>
                    <div class="content">
                        {{bigData.msg}}{{bigData.guest_msg}}
                    </div>
                </div>
                <div class="btm">
                    <span class="league" :style="{color: bigData.sclass_color}">{{bigData.sclass_name}}</span>
                    <span class="team"><em class="w">{{bigData.home_team}}</em> <em>{{bigData.match_state === '-1' ? (bigData.home_score + ':' + bigData.guest_score) : 'VS'}}</em> <em class="w">{{bigData.guest_team}}</em></span>
                    <span class="time">{{matchTime}}</span>
                </div>
                <div class="approval">
                    <p class="per">
                        <ChartsPie
                            id="bigPie"
                            :colors = "['#FF5048',isDark ? '#2f2f2f':'#eeeeee']"
                            :data="[maxStats, 100 - maxStats]"
                            type="big"
                            :text="maxStats + '%'"
                        />
                    </p>
                    <p class="txt">专家认可度</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isAndroid } from "../../utils/base";
import TitleBar from './common/titleBar.vue'
import ChartsPie from '../../components/datamodel/common/chartsPie.vue'
export default {
    name: 'bigReportCorpus',
    props: ['bigData'],
    components: {
        TitleBar,
        ChartsPie
    },
    watch: {
        data: {
            handler () {
                this.renderBigReport();
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        isAndroid () {
            return isAndroid()
        },
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    data () {
        return {
            type: "15",
            txt: '',
            matchTime: '',
            maxStats: 0
        }
    },
    methods: {
        renderBigReport () {
            if (this.bigData) {
                this.maxStats = this.bigData.six_home_stats >= this.bigData.six_guest_stats ? this.bigData.six_home_stats : this.bigData.six_guest_stats;
                this.matchTime = this.bigData.match_time.substring(2, 16).replace(/-/g, '.');
                if (this.bigData.type_num * 1 > 0) {
                    this.txt = '（昨日分析' + this.bigData.type_num + '场）';
                } else {
                    this.txt = '';
                }
            }
        },
        goModelList () {
            this.$emit('goDetail', this.type);
        }
    }
}
</script>

<style lang="less" scoped>
.bigReportContainer{
    width: 100%;
    .bigReportBox{
        width: 100%;
        padding: 0 14px;
        .bigReportCard{
            position: relative;
            width: 100%;
            padding: 10px 10px 0;
            background: #FFFFFF;
            border-radius: 5px;
            .top{
                padding-right: 65px;
                .title{
                    width: 100%;
                    font-size: 10px;
                    color: #333333;
                    overflow: hidden;
                    text-align: center;
                    .home{
                        float: left;
                        font-size: 12px;
                        font-weight: bold;
                    }
                    .guest{
                        float: right;
                        font-size: 12px;
                        font-weight: bold;
                    }
                }
                .barBox{
                    width: 100%;
                    height: 12px;
                    margin-top: 8px;
                    border-radius: 7.5px;
                    span{
                        position: relative;
                        display: inline-block;
                        width: auto;
                        height: 12px;
                        line-height: 12px;
                        padding: 0 5px;
                        font-size: 9px;
                        color: #FFFFFF;
                        vertical-align: middle;
                        &.home{
                            border-radius: 7.5px 0 0 7.5px;
                            background: #FF5048;
                            text-align: left;
                        }
                        &.guest{
                            border-radius: 0 7.5px 7.5px 0;
                            background: #169AFF;
                            text-align: right;
                        }
                        &.isAndroid{
                            padding-top: 1.5px;
                        }
                    }
                }
                .content{
                    width: 100%;
                    height: 30px;
                    margin-top: 8px;
                    font-size: 10px;
                    color: #666666;
                    line-height: 15px;
                    text-align: left;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
            .btm{
                width: 100%;
                height: 30px;
                line-height: 30px;
                margin-top: 10px;
                font-size: 10px;
                border-top: 1px solid #EEEEEE;
                text-align: center;
                .league{
                    float: left;
                    height: 30px;
                    width: 65px;
                    max-width: 65px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: left;
                }
                .team{
                    color: #333333;
                    em{
                        display: inline-block;
                        vertical-align: middle;
                        color: #FF5048;
                        &.w{
                            color: #333333;
                            max-width: 60px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
                .time{
                    float: right;
                    height: 30px;
                    color: #999999;
                }
            }
            .approval{
                position: absolute;
                right: 8px;
                top: 10px;
                .per{
                    font-weight: bold;
                    color: #171717;
                }
                .txt{
                    font-size: 10px;
                    color: #333333;
                    text-align: center;
                }
            }
        }
    }
}
.bigReportContainerDark{
    background-color: #191919;
    .bigReportBox {
        .bigReportCard{
            background: #232323;
            .top{
                .title {
                    color: #d3d3d3;
                }
                .barBox {
                    span {
                        color: #191919;
                    }
                }
                .content {
                    color: #a6a6a6;
                }
            }
            .btm {
                border-color: #2f2f2f;
                .team {
                    color: #d3d3d3;
                    em {
                        &.w {
                            color: #d3d3d3;
                        }
                    }
                }
                .team {
                    color: #a6a6a6;
                }
            }
            .approval {
                .per {
                    color: #FFFFFF;
                }
                .txt {
                    color: #d3d3d3;
                }
            }
        }
    }
}
</style>
